import { imageBackground } from '@/services/utils/imageVariants';

export default {
  name: 'PublicClubCard',
  props: { club: { type: Object, required: true }, place: { type: Object, default: null }, showAction: Boolean, showStats: { type: Boolean, default: true } },
  methods: { imageBackground },
};
